import { Box, Typography } from '@mui/material';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TrafficLightStatus } from '@work4all/models/lib/Enums/TrafficLightStatus.enum';

import { TrafficLightStatusIndicator } from '../../traffic-light-status-indicator/TrafficLightStatusIndicator';
import { FixedDataPicker } from '../fixed-data-picker/FixedDataPicker';
import { IPickerProps } from '../types';

const STATUSES = [
  TrafficLightStatus.UNSET,
  TrafficLightStatus.RED,
  TrafficLightStatus.YELLOW,
  TrafficLightStatus.GREEN,
];

type Props<TMultiple extends boolean> = IPickerProps<
  { id: string; name: string },
  TMultiple
>;

export const ProjectTrafficLightStatusPicker = <TMultiple extends boolean>(
  props: Props<TMultiple>
) => {
  const { t } = useTranslation();
  const data = useMemo(() => {
    return STATUSES.map((id) => {
      return {
        id,
        name: t(`TRAFFIC_LIGHT_STATUSES.${id}`),
      };
    });
  }, [t]);

  const renderItemContent = useCallback((status) => {
    return (
      <Box display="flex" alignItems="center">
        <TrafficLightStatusIndicator value={status.id} />

        <Typography variant="body2" noWrap marginLeft="4px">
          {status.name}
        </Typography>
      </Box>
    );
  }, []);

  return (
    <FixedDataPicker
      {...props}
      dataSet={data}
      renderItemContent={renderItemContent}
      clearable={false}
    />
  );
};
